const features = [
  {
    icon: 'ri-compass-3-line',
    title: '网址导航123',
    desc: '集成网址导航123、123导航、导航123等数字标识快捷入口，网址123轻松记，一键直达常用网站，告别繁琐的网址记忆和收藏夹翻找。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '热点实时追踪',
    desc: '全天候监控全网热点事件与吃瓜资讯，科技、娱乐、社会、财经等多维度覆盖，让你不错过任何一个值得关注的热门话题。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠导航',
    desc: '所有收录站点均经过人工审核，杜绝恶意跳转和钓鱼网站。上网导航有保障，保护你的隐私与设备安全不受侵害。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配体验',
    desc: '支持电脑、平板、手机全平台访问，响应式设计保证不同设备均能获得流畅的上网导航体验，随时随地快速上网。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            为什么选择51网址导航？四大核心优势让上网更简单
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200/60 transition-all duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl mb-4 transition-transform duration-200 group-hover:scale-110">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-base md:text-lg text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}